<template>
    <div class="consulting-management">
      <page-title title="筛选">
        <el-row class="consulting-management__filter-header" :gutter="20">
          <el-col :xl="6" :span="8">
            <span>咨询时间：</span>
            <el-date-picker
              v-model="filter.dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-col>
          <el-col :xl="3" :span="6">
            <el-button @click="search">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </page-title>
      <page-title title="数据列表">
        <div class="consulting-management__body">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ backgroundColor: `#f7f7f7` }"
          >
            <el-table-column prop="content" label="咨询内容"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="phone" label="联系电话"></el-table-column>
            <el-table-column prop="createTime" label="咨询时间"></el-table-column>
            <el-table-column prop="remark" label="备注内容"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openRemarkDialog(scope.row)"
                  >修改备注</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <cus-pagination
            :total="total"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            @current-change="getList"
            @size-change="search"
          ></cus-pagination>
        </div>
      </page-title>
  
      <!-- 修改备注弹窗 -->
      <el-dialog
        title="修改备注"
        :visible.sync="remarkDialogVisible"
        width="50%"
        append-to-body>
        <el-form :model="remarkForm" label-width="80px">
          <el-form-item label="当前备注">
            <el-input
              v-model="remarkForm.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入新的备注内容"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="remarkDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveRemark">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import PageTitle from "@/components/pageTitle.vue";
  import CusPagination from "@/components/cusPagination.vue";
  import { updateRemark,listAll,updateCounsel } from "@/api/consulting";
  
  export default {
    components: {
      PageTitle,
      CusPagination
    },
    data() {
      return {
        loading: true,
        filter: {
          dateRange: []
        },
        tableData: [
         
        ],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        remarkDialogVisible: false,
        remarkForm: {
          id: '',
          remark: ''
        },
        remarkHistory: [],
        currentConsulting: null
      };
    },
    methods: {
      async getList() {
        this.loading = true;
        const params = {
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          beginTime: this.filter.dateRange?.[0] || '',
          endTime: this.filter.dateRange?.[1] || ''
        };
        
        try {
          const { data } = await this.$ajax.get(listAll, params);
          this.tableData = data?.data?.records || [];
          this.total = data?.data?.total || 0;
        } finally {
          this.loading = false;
        }
      },
      search() {
        this.currentPage = 1;
        this.getList();
      },
      reset() {
        this.filter.dateRange = [];
        this.search();
      },
      openRemarkDialog(row) {
        this.currentConsulting = row;
        this.remarkForm = {
          id: row.id,
          remark: row.remark
        };
        // 这里应该调用接口获取历史记录
        this.remarkDialogVisible = true;
      },
      async saveRemark() {
        try {
          await this.$ajax.post(updateCounsel, {
            id: this.remarkForm.id,
            remark: this.remarkForm.remark
          });
          this.$message.success('备注修改成功');
          this.remarkDialogVisible = false;
          this.search();
        } catch (error) {
          this.$message.error('备注修改失败');
        }
      }
    },
    mounted() {
      this.getList();
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .consulting-management {
    .box-card {
      margin-bottom: 20px;
    }
  
    &__filter-header {
      display: flex;
      align-items: center;
    }
  
    &__body {
      .el-button {
        color: #005bff;
      }
  
      .el-table {
        border: 1px solid #ebeef5;
        border-bottom: none;
        margin-bottom: 20px;
      }
    }
  }
  </style>